import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/editReportRequiredStatus/${number | ':reportTypeId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/editReportRequiredStatus/:reportTypeId`;

export const URL = (id: number): RouteDefinition => `${baseRoute}/editReportRequiredStatus/${id}`;
